import type { ReactNode } from "react"

import { ShowWhenTrue } from "@/components/conditionals"
import { BodyBase } from "@/domains/design/components/body-base"
import { Heading3 } from "@/domains/design/components/heading3"
import { Breadcrumb, BreadcrumbItem } from "@/domains/navigation"

type IPageTitle = {
  title: string
  subTitle?: ReactNode
  items?: BreadcrumbItem[]
  middleItem?: ReactNode
  middleEndItem?: ReactNode
  bottomItem?: ReactNode
}

export const PageTitle = ({ title, items, middleItem, middleEndItem, bottomItem, subTitle }: IPageTitle) => {
  return (
    <div className="mb-8">
      <div className="mb-2 flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
        <div>
          <Heading3 className="tracking-tight">{title}</Heading3>
          {subTitle != null && <BodyBase className="mt-2 max-w-3xl text-t200">{subTitle}</BodyBase>}
        </div>
        {(middleItem != null || middleEndItem != null) && (
          <div className="flex flex-wrap items-center gap-2">
            {middleItem != null && middleItem}
            {middleEndItem != null && middleEndItem}
          </div>
        )}
      </div>
      <ShowWhenTrue when={items != null}>
        <div className="mb-1 mt-1">{items ? <Breadcrumb items={items} /> : null}</div>
      </ShowWhenTrue>
      <ShowWhenTrue when={bottomItem != null}>
        <div>{bottomItem}</div>
      </ShowWhenTrue>
    </div>
  )
}
